// This file was automatically generated from appchart.dialog.ordermed.viewRxOrderSets.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appchart.dialog.ordermed.viewRxOrderSets');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.ordermed.viewRxOrderSets.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div><p class="el8Italic el8Gray el8AlignCenter mt10">Click an Rx Template to add it to your order</p><p class="el8AlignCenter"><a href="/settings/prescriptions/" target="_blank" rel="noopener">add/edit/delete Rx Templates</a></p><div id="view-rx-order-sets-list"></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.ordermed.viewRxOrderSets.list = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.orderSets.length) {
    output.append('<ul class="ordersetContainer padt20"><li class="padh5"><div class="el8VAlignTop el8BrandDark el8StrongMiniHeading el8InlineBlock w42">Name</div><div class="el8VAlignTop el8BrandDark el8StrongMiniHeading el8InlineBlock w33">Sig</div><div class="el8VAlignTop el8BrandDark el8StrongMiniHeading el8InlineBlock w15">Quantity</div><div class="el8VAlignTop el8BrandDark el8StrongMiniHeading el8InlineBlock w8">Refills</div></li>');
    var medOrderTemplateList2050 = opt_data.orderSets;
    var medOrderTemplateListLen2050 = medOrderTemplateList2050.length;
    for (var medOrderTemplateIndex2050 = 0; medOrderTemplateIndex2050 < medOrderTemplateListLen2050; medOrderTemplateIndex2050++) {
      var medOrderTemplateData2050 = medOrderTemplateList2050[medOrderTemplateIndex2050];
      output.append('<li class="order-set-item select-trigger rxItem" data-id="', soy.$$escapeHtml(medOrderTemplateData2050.id), '"><div class="el8VAlignTop el8StandardFontSize el8Bold el8InlineBlock w42">', soy.$$escapeHtml(medOrderTemplateData2050.name), '</div><div class="el8VAlignTop el8StandardFontSize el8InlineBlock w33">', (medOrderTemplateData2050.directions) ? soy.$$escapeHtml(medOrderTemplateData2050.directions) : '', '</div><div class="el8VAlignTop el8StandardFontSize el8InlineBlock w15">', (medOrderTemplateData2050.qty) ? soy.$$escapeHtml(medOrderTemplateData2050.qty) + ' ' : '', (medOrderTemplateData2050.qtyUnits) ? soy.$$escapeHtml(medOrderTemplateData2050.qtyUnits) : '', '</div><div class="el8VAlignTop el8StandardFontSize el8InlineBlock w8">', (medOrderTemplateData2050.authRefills != null) ? soy.$$escapeHtml(medOrderTemplateData2050.authRefills) : '', '</div></li>');
    }
    output.append('</ul>');
  } else {
    output.append('<p class="el8FeedEmpty">You have no saved Rx Templates</p>');
  }
  if (!opt_sb) return output.toString();
};
